import { render, staticRenderFns } from "./table-chart-loader.vue?vue&type=template&id=505bac0c&scoped=true"
import script from "./table-chart-loader.vue?vue&type=script&lang=js"
export * from "./table-chart-loader.vue?vue&type=script&lang=js"
import style0 from "./table-chart-loader.vue?vue&type=style&index=0&id=505bac0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505bac0c",
  null
  
)

export default component.exports